// ▼ HTMLの調整

export default class {
  constructor() {
    // ▼ 矢印アイコンを付与
    const iconArw = document.querySelectorAll(".-icon-arw, .is-style-icon-arw, .newsPost .wp-block-button__link");
    iconArw.forEach((element) => {
      // もしelement自体がaタグではなく、中にaタグがある場合（ブロックエディタで親要素にクラスが付与された場合）
      if (element.tagName.toLowerCase() !== 'a') {
        const aTag = element.querySelector('a');
        if (aTag) {
          aTag.innerHTML = aTag.innerHTML + '<i class="icon-arw"></i>';
          return;
        }
      }
      // それ以外（直接aタグに付与された場合など）
      element.innerHTML = element.innerHTML + '<i class="icon-arw"></i>';
    });
  }
}
